// extracted by mini-css-extract-plugin
module.exports = {"loading-layout":"index__loading-layout___2ozUZ","loadingLayout":"index__loading-layout___2ozUZ"};